export function copyToClipboard(text: string) {
	return async function copyToClipboardImpl() {
		await navigator.clipboard.writeText(text);
	};
}
